module.exports = __webpack_public_path__ + "static/media/stripe_jcb.271fd06e.svg";